import { Controller } from "@hotwired/stimulus"

export default class extends Controller<HTMLFormElement> {
  submitIfMaxLengthReached({ target }: InputEvent) {
    if (target instanceof HTMLInputElement && target.maxLength === target.value.length) {
      this.element.requestSubmit()
    }
  }
}
